export interface PropertyTypeValue {
  key: string;
  value: string;
}

// shared backing store
const PROPERTY_TYPE_MAP: Record<string, string> = {};

// 1) One-time/init logic (called from catalog/endpoint code)
export function initPropertyTypeMap(values: PropertyTypeValue[]): void {
  for (const { key, value } of values) {
    PROPERTY_TYPE_MAP[key] = value;
  }
}

// 2) Reusable read logic (used everywhere else)
export function getPropertyTypeLabel(raw: string | null | undefined): string {
  if (!raw) return '';
  // primary: exact match
  const direct = PROPERTY_TYPE_MAP[raw];
  if (direct != null) {
    return direct;
  }

  // fallback: case-insensitive match (handles variants like "LIFE SCIENCE LABS")
  const lowerRaw = raw.toLowerCase();
  for (const key of Object.keys(PROPERTY_TYPE_MAP)) {
    if (key.toLowerCase() === lowerRaw) {
      return PROPERTY_TYPE_MAP[key];
    }
  }

  return raw;
}

export function getPropertyTypeOptions(): PropertyTypeValue[] {
  return Object.entries(PROPERTY_TYPE_MAP).map(([key, value]) => ({ key, value }));
}
